import React from 'react';

const GlowOrbs = () => {
  return (
    <>
      <div className="glow-orb glow-orb-1" aria-hidden="true" />
      <div className="glow-orb glow-orb-2" aria-hidden="true" />
    </>
  );
};

export default GlowOrbs;
